import { render, staticRenderFns } from "./SectionPair.vue?vue&type=template&id=0149ef3d"
import script from "./SectionPair.vue?vue&type=script&lang=js"
export * from "./SectionPair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports